import request from '@lib/request'

// 删除老师
function DelTeacher({
  id // 老师id
}) {
  return request
    .post('/institutionAdmin/teacher/del', {
      id
    })
    .then(response => {
      return response.data
    })
}
// 编辑老师
function EditTeacher({
  id,
  name
}) {
  return request
    .post('/institutionAdmin/teacher/edit', {
      id,
      name
    })
    .then(response => {
      return response.data
    })
}
// 新增老师
function CreateTeacher({
  mobile,
  name
}) {
  return request
    .post('/institutionAdmin/teacher/add', {
      mobile,
      name
    })
    .then(response => {
      return response.data
    })
}
// 删除管理员
function DelAdmin({
  id, // 管理员id
  type
}) {
  return request
    .post('/institutionAdmin/teacher/del', {
      id,
      type
    })
    .then(response => {
      return response.data
    })
}
// 编辑管理员
function EditAdmin({
  id,
  name,
  type
}) {
  return request
    .post('/institutionAdmin/teacher/edit', {
      id,
      name,
      type
    })
    .then(response => {
      return response.data
    })
}
// 新增管理员
function CreateAdmin({
  mobile,
  name,
  type
}) {
  return request
    .post('/institutionAdmin/teacher/add', {
      mobile,
      name,
      type
    })
    .then(response => {
      return response.data
    })
}
// 管理员列表
function GetAdminList({
  keyword,
  start,
  rows,
  type
}) {
  return request
    .get('/institutionAdmin/teacher/list', {
      params: {
        keyword,
        start,
        rows,
        type
      }
    })
    .then(result => {
      return result.data
    })
}
// 班级列表
function GetClassList({
  keyword,
  status,
  start,
  rows
}) {
  return request
    .get('/institutionAdmin/group/list', {
      params: {
        keyword,
        status,
        start,
        rows
      }
    })
    .then(result => {
      return result.data
    })
}
// 新增班级
function CreateClass({
  name,
  teacherId,
  adminId,
  isAllow,
  classQrCode,
  classMobile,
  classAddress,
  partName
}) {
  return request
    .post('/institutionAdmin/group/add', {
      name,
      teacher_id: teacherId,
      group_admins: adminId,
      is_allow: isAllow,
      contact_qrcode: classQrCode,
      contact_mobile: classMobile,
      contact_address: classAddress,
      part_name: partName
    })
    .then(response => {
      return response.data
    })
}

// 编辑班级
function EditClass({
  id,
  name,
  teacherId,
  adminId,
  isAllow,
  classQrCode,
  classMobile,
  classAddress,
  partName
}) {
  return request
    .post('/institutionAdmin/group/edit', {
      id,
      name,
      teacher_id: teacherId,
      group_admins: adminId,
      is_allow: isAllow,
      contact_qrcode: classQrCode,
      contact_mobile: classMobile,
      contact_address: classAddress,
      part_name: partName
    })
    .then(response => {
      return response.data
    })
}
// 编辑学生
function EditStudent({
  batchId,
  id,
  classId,
  name,
  aiBatchId,
  password
}) {
  return request
    .post('/institutionAdmin/student/edit', {
      batch_id: batchId,
      uid: id,
      group_id: classId,
      name,
      chatai_batch_id: aiBatchId,
      password
    })
    .then(response => {
      return response.data
    })
}

// 编辑学生关联班级
function EditStudentClass({
  uid,
  group_ids
}) {
  return request
    .post('/institutionAdmin/student/editGroup', {
      uid,
      group_ids
    })
    .then(response => {
      return response.data
    })
}

// 上架/下架班级
function StartClass({
  id,
  status
}) {
  return request
    .post('/institutionAdmin/group/setStatus', {
      id,
      status
    })
    .then(response => {
      return response.data
    })
}

// 学生列表
function GetStudentList({
  keyword,
  batch_id,
  start,
  rows,
  organId,
  groupId
}) {
  return request
    .get('/institutionAdmin/student/list', {
      params: {
        keyword,
        batch_id,
        start,
        rows,
        institution_id: organId,
        group_id: groupId
      }
    })
    .then(result => {
      return result.data
    })
}
// 删除学生
function DelStudent({
  uid,
  group,
  withoutPermission = false
}) {
  return request
    .post('/institutionAdmin/student/del', {
      uid,
      group_id: group,
      retain_vip: withoutPermission ? 1 : 0
    })
    .then(response => {
      return response.data
    })
}
// 新增学生
function CreatStudent({
  batch,
  name,
  mobile,
  group,
  id,
  aiBatchId
}) {
  return request
    .post('/institutionAdmin/student/add', {
      batch_id: batch,
      name,
      mobile,
      group_ids: group,
      svip_id: id,
      chatai_batch_id: aiBatchId
    })
    .then(response => {
      return response.data
    })
}
// 解绑SVIP
function DelSvip({
  uid,
  group,
  organId
}) {
  return request
    .post('/institutionAdmin/student/unBindSvip', {
      uid,
      group_id: group,
      institution_id: organId
    })
    .then(response => {
      return response.data
    })
}
// 上传文excel件
function UploadExcel({
  stus,
  groupId,
  svipId,
  batchId,
  aiBatchId
}) {
  const form = new FormData()
  form.append('stus', stus)
  form.append('group_ids', groupId)
  form.append('svip_id', svipId)
  form.append('batch_id', batchId)
  form.append('chatai_batch_id', aiBatchId)
  return request
    .post('/institutionAdmin/student/excelImportStudent', form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => {
      return response.data
    })
}
// 绑定SVIP
function BindStudentSvip({
  uid,
  group,
  id,
  organId
}) {
  return request
    .post('/institutionAdmin/student/bindSvip', {
      uid,
      group_id: group,
      svip_id: id,
      institution_id: organId
    })
    .then(response => {
      return response.data
    })
}
// 获取机构svip卡
function GetSvipCard({
  platform,
  start,
  rows
}) {
  return request
    .get('/institutionAdmin/institution/svip', {
      params: {
        keyword: platform,
        start,
        rows
      }
    })
    .then(result => {
      return result.data
    })
}

// 预约申请
function GetApplyList({
  startTime,
  endTime,
  start,
  rows
}) {
  return request
    .get('/institutionAdmin/bookingExperience/list', {
      params: {
        start_time: startTime,
        end_time: endTime,
        start,
        rows
      }
    })
    .then(result => {
      return result.data
    })
}

// 预约申请
// function BindStudentBatch({ stuid, batchId }) {
//   return request
//     .get('/institutionAdmin/institutionBatch/updateStudentsBatch', {
//       params: {
//         $stu_ids: stuid,
//         $batch_id: batchId
//       }
//     })
//     .then(result => {
//       return result.data
//     })
// }
// 绑定SVIP
function BindStudentBatch({
  stuid,
  batchId,
  aiBatchId
}) {
  return request
    .post('/institutionAdmin/institutionBatch/updateStudentsBatch', {
      stu_ids: stuid,
      batch_id: batchId,
      chatai_batch_id: aiBatchId
    })
    .then(response => {
      return response.data
    })
}
// 生成订单信息
function GetOrderInfo({
  account,
  type,
  batchId,
  days,
  stuNum,
  Ctype,
  startTime,
  app
}) {
  return request
    .post('/institutionAdmin/institutionBatchBuy/buyBatch', {
      admin_account: account,
      type,
      batch_id: batchId,
      days,
      stu_num: stuNum,
      cooperation_type: Ctype,
      start_time: startTime,
      from_app: app
    })
    .then(response => {
      return response.data
    })
}

// 查询订单状态
function GetOrderStatus({
  id
}) {
  return request
    .get('/institutionAdmin/institutionBatchBuy/checkBuy', {
      params: {
        order_id: id
      }
    })
    .then(result => {
      return result.data
    })
}

// 编辑学生关联班级
function SwitchStudentClass({
  uids,
  group_ids
}) {
  return request
    .post('/institutionAdmin/student/multiAddGroup', {
      uids,
      group_ids
    })
    .then(response => {
      return response.data
    })
}

export default {
  DelTeacher,
  EditTeacher,
  DelAdmin,
  EditAdmin,
  CreateTeacher,
  GetAdminList,
  CreateAdmin,
  GetClassList,
  CreateClass,
  EditClass,
  StartClass,
  GetStudentList,
  DelStudent,
  DelSvip,
  BindStudentSvip,
  GetSvipCard,
  UploadExcel,
  CreatStudent,
  EditStudent,
  EditStudentClass,
  GetApplyList,
  BindStudentBatch,
  GetOrderInfo,
  GetOrderStatus,
  SwitchStudentClass
}
